// extracted by extract-css-chunks-webpack-plugin
module.exports = {"permissionDetails":"PermissionEntryEditable__permissionDetails___1yne5","spacer":"PermissionEntryEditable__spacer___1cMw4","permissionSelect":"PermissionEntryEditable__permissionSelect___314O1","permissionOwner":"PermissionEntryEditable__permissionOwner___28hpZ"};
    if(module.hot) {
      // 1778083493564
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  